const routes = [
  {
    // 中信拉新发券-首页
    path: '/citicLachine',
    name: 'citicLachine',
    component: () => import('@/views/citicBank/lachine/index.vue'),
    meta: {
      requiresAuth: false,
      title: '中信银行'
    }
  },
  {
    // 中信拉新-落地页1
    path: '/citicLandingPage1',
    name: 'citicLandingPage1',
    component: () => import('@/views/citicBank/landingPage/page1.vue'),
    meta: {
      requiresAuth: false,
      title: '中信银行'
    },

  },

]

export default routes
